import { endpoint } from "views/pages/manage/common/constant";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { updateRequest } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { regex } from "views/pages/manage/common/constant/regex/index";
import { masterServiceBaseUrl } from "services/http";

const ALLOWED_PROGRAM_ACTIONS = ["APPL", "MATR", "BTCG", "RADM", "FOLO", "DISC", "APPL"];


export const getDropdowns = async () => {
    const dropdown = await Promise.all([
        dropdownMapping(
            endpoint.academic_career.getAllActive,
            "academicCareerDispValue",
            "id"
        ),
        dropdownMapping(
            endpoint.groupCode.getAllActive,
            "groupCodeDispValue",
            "id"
        ),
        dropdownMapping(
            endpoint.companyCode.getAllActive,
            "companyCodeDispValue",
            "id"
        ),
        dropdownMapping(
            endpoint.item_type_setup.getAllActive,
            "itemTypeId",
            "id",
            "description"
        ),
        dropdownMapping(
            endpoint.academic_group.getAllActive,
            "academicGroupDispValue",
            "id",
        ),
        dropdownMapping(
            endpoint.businessArea.getAllActiveV2,
            "businessAreaDispValue",
            "id",
            "businessAreaDesc"
        ),
        dropdownMapping(`${masterServiceBaseUrl}/programAction/getAllProgramAction`, 'programActionKey', 'programActionKey', "programActionDesc"),

    ]);
    return {
        academicCareer: dropdown[0],
        businessGroup: dropdown[1],
        companyCode: dropdown[2],
        minimumItemType: dropdown[3],
        academicGroup: dropdown[4],
        businessArea: dropdown[5],
        programActions: dropdown[6]?.filter(pA => ALLOWED_PROGRAM_ACTIONS?.includes(pA?.value)),
        mode: [{ label: 'OFFLINE', value: 'OFFLINE' }, { label: 'ONLINE', value: 'ONLINE' }]
    };
}

export const newRow = {
    businessGroup: "",
    companyCode: "",
    businessArea: "",
    academicCareer: "",
    minimumItemType: "",
    programActions: "",
    afterStartDate: "",
    beforeStartDate: "",
    transferLimit: "",
    duePayment: "NOT ALLOWED",
    createdBy: "",
    createdOn: "",
    updatedBy: "",
    status: "ACTIVE"
}

export const FILTER__FORM_FIELDS_GLOBAL = {
    careerIds: [],
    businessAreaIds: []
};

export const searchInputOptions = [
    {
        label: 'Career',
        keyName: 'career',
        placeholder: 'Search',
        errorMsg: 'Please Enter Career',
        regex: regex.alphabetsWithSpace,
        isValidInput: val => val && val?.trim()?.length !== 0,
    },
    {
        label: 'Business Area',
        keyName: 'businessArea',
        placeholder: 'Search',
        errorMsg: 'Please Enter valid Business Area',
        regex: regex.alphabetsWithSpace,
        isValidInput: val => val && val?.trim()?.length !== 0,
    }
];

//businessArea 0 for Pan India else business Area itself
export const getCreateUpdateReqBody = (rowData) => {
    const row = updateRequest(rowData);
    const { id, businessGroup, companyCode, businessArea, academicCareer, minimumItemType, programActions, afterStartDate, beforeStartDate, transferLimit, duePayment, status } = row;
    return {
        id: id || 0,
        businessGroupId: businessGroup || '',
        companyCodeId: companyCode || '',
        businessAreaId: businessArea || 0,
        academicCareerId: academicCareer || '',
        minimumItemType: rowData?.minimumItemType?.label || '',
        programActions: Array.isArray(rowData?.programActions)
            ? rowData.programActions.map(p => p.label)
            : [],
        afterStartDate: Number(afterStartDate) || 0,
        beforeStartDate: Number(beforeStartDate) || 0,
        transferLimit: transferLimit,
        duePayment: duePayment,
        status: status
    }
}

export const getStatusStyles = (status) => {
    if (status === "ACTIVE") {
        return {
            bgColor: "#E6F4ED",
            textColor: "#07794C",
        };
    } else {
        return {
            bgColor: "#FCEEED",
            textColor: "#DC2804",
        };
    }
};

export const duePaymentOptions = {
    onValue: { label: 'Allowed', value: 'ALLOWED' },
    offValue: { label: 'Not allowed', value: 'NOT ALLOWED' },
}
